import { PRICING_TYPES } from '@constants';

export const vehicleFuelTypesOptionsSelector = (state) => {
  if (!state?.vehicles?.vehicle?.enums?.fuelTypes) {
    return [];
  }
  return state.vehicles.vehicle.enums.fuelTypes.map((item) => {
    return {
      text: item.name,
      value: item.id,
    };
  });
};

export const vehicleCategoriesOptionsSelector = (state) => {
  if (!state?.vehicles?.vehicle?.enums?.categories) {
    return [];
  }
  return state.vehicles.vehicle.enums.categories.map((item) => {
    return {
      text: item.name,
      value: item.id,
    };
  });
};

export const vehicleEuroClassesOptionsSelector = (state) => {
  if (!state?.vehicles?.vehicle?.enums?.euroClasses) {
    return [];
  }
  return state.vehicles.vehicle.enums.euroClasses.map((item) => {
    return {
      text: item.name,
      value: item.id,
    };
  });
};

export const vehicleAvailabilitiesOptionsSelector = (state) => {
  if (!state?.vehicles?.vehicle?.enums?.availabilities) {
    return [];
  }
  return state.vehicles.vehicle.enums.availabilities.map((item) => {
    return {
      text: item.name,
      value: item.id,
    };
  });
};

export const vehicleEngineTypesOptionsSelector = (state) => {
  if (!state?.vehicles?.vehicle?.enums?.engineTypes) {
    return [];
  }
  return state.vehicles.vehicle.enums.engineTypes.map((item) => {
    return {
      text: item.name,
      value: item.id,
    };
  });
};

export const vehicleTransmissionsOptionsSelector = (state) => {
  if (!state?.vehicles?.vehicle?.enums?.transmissions) {
    return [];
  }
  return state.vehicles.vehicle.enums.transmissions.map((item) => {
    return {
      text: item.name,
      value: item.id,
    };
  });
};

export const vehicleWheelDriveOptionsSelector = (state) => {
  if (!state?.vehicles?.vehicle?.enums?.wheelDrives) {
    return [];
  }
  return state.vehicles.vehicle.enums.wheelDrives.map((item) => {
    return {
      text: item.name,
      value: item.id,
    };
  });
};

export const vehicleBodyTypesOptionsSelector = (state) => {
  if (!state?.vehicles?.vehicle?.enums?.bodyTypes) {
    return [];
  }
  return state.vehicles.vehicle.enums.bodyTypes.map((item) => {
    return {
      text: item.name,
      value: item.id,
    };
  });
};

export const vehicleBodySizesOptionsSelector = (state) => {
  if (!state?.vehicles?.vehicle?.enums?.bodySizes) {
    return [];
  }
  return state.vehicles.vehicle.enums.bodySizes.map((item) => {
    return {
      text: item.name,
      value: item.id,
    };
  });
};

export const vehicleProductLinesOptionsSelector = (state) => {
  if (!state?.vehicles?.vehicle?.enums?.productLines) {
    return [];
  }
  return state.vehicles.vehicle.enums.productLines.map((item) => {
    return {
      text: item.name,
      value: item.id,
    };
  });
};

export const vehicleInteriorTypesOptionsSelector = (state) => {
  if (!state?.vehicles?.vehicle?.enums?.interiorTypes) {
    return [];
  }
  return state.vehicles.vehicle.enums.interiorTypes.map((item) => {
    return {
      value: item?.slug,
      text: item?.name_el,
    };
  });
};

export const vehicleAllowedMonthlyKmOptionsSelector = (state) => {
  if (!state?.vehicles?.vehicle?.enums?.allowedMonthlyKm) {
    return [];
  }
  return state.vehicles.vehicle.enums.allowedMonthlyKm.map((item) => {
    return {
      text: item.name,
      value: item.id,
    };
  });
};

export const availableTagsSelector = (state) => {
  let tagsCheckBoxes = {};
  state?.vehicles?.vehicle?.enums?.availableTags?.forEach((item) => {
    const checkBox = {};
    checkBox[item] = {
      type: 'checkbox',
      label: '',
      checkboxLabel: item,
      defaultValue: false,
      rules: {},
    };
    tagsCheckBoxes = { ...tagsCheckBoxes, ...checkBox };
  });
  return tagsCheckBoxes;
};

export const vehicleManufacturersOptionsSelector = (state) => {
  if (!state?.vehicles?.vehicle?.manufacturers) {
    return [];
  }
  return state?.vehicles?.vehicle?.manufacturers;
};

export const vehicleModelsOptionsSelector = (state) => {
  if (!state?.vehicles?.vehicle?.modelObj) {
    return {};
  }
  return state?.vehicles?.vehicle?.modelObj;
};

export const vehicleIntitialPriceSelector = (state) => {
  if (!state?.vehicles?.vehicle?.vehicle) {
    return '';
  }
  const openPrice = state?.vehicles?.vehicle?.vehicle?.pricing?.find((item) => {
    return item?.type === PRICING_TYPES.open;
  });

  return openPrice?.initialPrice || '';
};

export const vehiclePriceSelector = (state) => {
  if (!state?.vehicles?.vehicle?.vehicle) {
    return '';
  }
  const openPrice = state?.vehicles?.vehicle?.vehicle?.pricing?.find((item) => {
    return item?.type === PRICING_TYPES.open;
  });

  return openPrice?.price || '';
};

export const vehiclePrimaryImageSelector = (state) => {
  if (!state?.vehicles?.vehicle?.vehicle) {
    return '';
  }

  return state?.vehicles?.vehicle?.vehicle.selectedImageId
    ? state?.vehicles?.vehicle?.vehicle.images?.find(
        (image) =>
          image?.id === state?.vehicles?.vehicle?.vehicle.selectedImageId
      )?.url
    : state?.vehicles?.vehicle?.vehicle.images?.[0]?.url;
};

export const vehicleAvailabilitySelector = (state) => {
  if (
    !state?.vehicles?.vehicle?.vehicle ||
    !state?.vehicles?.vehicle?.enums?.availabilities
  ) {
    return '';
  }

  return state.vehicles.vehicle.enums.availabilities.find(
    (item) => item.id === state.vehicles.vehicle.vehicle.availability
  )?.name;
};

export const vehicleBodyTypeSelector = (state) => {
  if (
    !state?.vehicles?.vehicle?.vehicle ||
    !state?.vehicles?.vehicle?.enums?.bodyTypes
  ) {
    return '';
  }

  return state.vehicles.vehicle.enums.bodyTypes.find(
    (item) => item.id === state.vehicles.vehicle.vehicle.properties?.body?.type
  )?.name;
};
export const categoryClassesSelector = (state) => {
  if (!state?.vehicles?.vehicle?.enums?.categoryClasses) {
    return [];
  }
  return state?.vehicles?.vehicle?.enums?.categoryClasses;
};
export const riskCategoriesSelector = (state) => {
  if (!state?.vehicles?.vehicle?.enums?.riskCategories) {
    return [];
  }
  return state?.vehicles?.vehicle?.enums?.riskCategories;
};
